import * as React from 'react';
import * as LogRocket from 'logrocket';
import moment from 'moment';
import injectSheet from 'react-jss';
import AddCustomer from './AddCustomer';
import Select from 'src/components/common/Select';
import { connect, ConnectedProps } from 'react-redux';
import { MIN_WIDTH } from 'src/globals';
import { fetchAllTeams } from 'src/api/teams';
import { CardData } from './Interfaces/Shipment.interface';
import { prettifyString } from 'src/utils/utils';
import { FormComponentProps } from 'antd/lib/form';
import { sendIntercomEvent } from 'src/utils/intercomService';
import { withRouter } from 'react-router';
import { searchStakeholder } from 'src/api/masters';
import { getContainerTrackingRoute } from 'src/routing/utils';
import {
  AccessTypes,
  KeyLabel,
  RouterProps,
  StylesProps,
  CustomFields,
} from 'src/Library/Types';
import { isValidArray, isValidNumber, stops, isValidBoolean, getUniqFromArray } from 'src/Library/Helper';
import { sendEvent, EventCategories } from 'src/utils/gaService';
import {
  quickAddBL,
  quickAddContainer,
  editShipment,
  getCustomFields,
} from 'src/api/shipmentTracking';
import {
  buildCustomFieldsPayload,
  getCustomFieldInitialValue,
  filterActiveCustomFields,
} from './customFields.helper';
import {
  Button,
  Form,
  Modal,
  Row,
  Col,
  Input,
  message,
  Radio,
  Collapse,
  Icon,
  Checkbox,
  DatePicker,
  Tag,
  Spin,
  Tooltip,
} from 'antd';
import {
  SHIPMENT_TYPE,
  MOVEMENT_TYPES,
  ENTITIES,
  ACCESS_TYPE_TEXT,
} from './ContainerUtils';
import {
  NumberRule,
  alphaNumericWithSpecialChars,
} from 'src/utils/FormValidationRules';
import { IdLabel, Document } from './Interfaces/TypesInShipmentTracking';
import { useGenericState } from 'src/Library/UseGenericState';
import SearchTagsInput from 'src/components/common/SearchTagsInput';
import { searchProduct } from '../masters/Product/Product.api';
import SelectPort from 'src/components/common/CommonSelect/SelectPort';
import SelectImportAddressModal from './SelectImportAddressModal';
import { Address } from 'src/components/common/Types/CommonTypes';
import { QuickAddContainerTrackingStyles } from './QuickAddContainerTracking.styles';
import { getFormattedAddress } from '../Triangulation/ContainerTriangulation.utils';
import isEmpty from 'lodash/isEmpty';
import { fetchAddresses } from 'src/api/organisationProfiling';
import { SEConsignorAddress } from '../shipment-execution/SE.interfaces';
import { defaultAccessKeys } from '../Enquiry/InquiryUtils';
import SelectDocuments from 'src/components/common/CommonSelect/SelectDocuments';
import uuid from 'uuid';
import SelectIncoterm from 'src/components/common/CommonSelect/SelectIncoterm';
import { tokens } from 'src/design-system';
import TrackingDuplicateConfirmationModal from 'src/components/pages/shipment-execution/SEActions/Tracking/TrackingDuplicateConfirmationModal';
import _ from 'lodash';
import { fetchAllUsersOfCurrentOrg } from 'src/api/users';
import { renderSelectDropDown } from 'src/Library/Common';
import TextArea from 'antd/lib/input/TextArea';

type ReactElement = React.ReactElement;

const FormItem = Form.Item;
const Option = Select.Option;

interface IProps extends FormComponentProps,
  ReduxProps, StylesProps<ReturnType<typeof QuickAddContainerTrackingStyles>>, RouterProps {
  blToFill: string;
  hblToFill?: string;
  bookingToFill: string;
  showHBL: boolean;
  typeAdd: string;
  containerToFill: string;
  editData: CardData;
  isVisible: boolean;
  onClose: (options?) => void;
  visibleAccessTypes: string[];
  backRoute?: string;
  allowedDocumentTypes: Record<string, string>;
  callback?: () => void; // from landing page to hide landing page
}

enum TrackingTypeLabel {
  CONTAINER = 'Container',
  BL = 'BL',
  BOOKING = 'Booking',
  HBL = 'HBL'
};

interface StateProps {
  isSaving: boolean;
  customers: IdLabel[];
  searching: boolean;
  isAddCustomerModal: boolean;
  isAddSupplierModal: boolean;
  originSame: boolean;
  destinationSame: boolean;
  movementType: string;
  suppliers: IdLabel[];
  accessType?: AccessTypes;
  teamOptions: KeyLabel[];
  teams?: string[];
  isSearching: boolean;
  addType: TrackingTypeLabel;
  searchTerm: string;
  productList: KeyLabel[];
  customerProduct?: KeyLabel[];
  shipperProduct?: KeyLabel[];
  supplierProduct?: KeyLabel[];
  originCountry?: string;
  destinationCountry?: string;
  isSelectAddressModalVisible?: boolean;
  selectedImportAddress?: Address;
  isFetchingAddress?: boolean;
  addressList?: SEConsignorAddress[];
  vendors: IdLabel[];
  isErrorModalVisible?: boolean;
  failureArray?: Array<{ reasons?: Array<{ message?: string }>; objectId?: string }>;
}

const QuickAddContainerTracking = (props: IProps) => {
  const [state, setState] = useGenericState<StateProps>({
    isSaving: false,
    customers: [],
    searching: false,
    isAddCustomerModal: false,
    isAddSupplierModal: false,
    originSame: false,
    destinationSame: false,
    movementType: MOVEMENT_TYPES.TRADE,
    suppliers: [],
    accessType: undefined,
    teamOptions: [],
    isSearching: false,
    addType: TrackingTypeLabel.BL,
    searchTerm: '',
    productList: [],
    vendors: [],
  });

  const [documentList, setDocuments] = React.useState<Document[]>([{ id: uuid() }]);
  const [customFields, setCustomFields] = React.useState<CustomFields[]>([]);

  const handleErrorModalClose = () => setState({ isErrorModalVisible: false, failureArray: [] });

  const {
    isSaving,
    customers,
    searching,
    originSame,
    destinationSame,
    suppliers,
    accessType,
    teamOptions,
    isSearching,
    addType,
    searchTerm,
    productList,
    originCountry,
    destinationCountry,
    isSelectAddressModalVisible,
    selectedImportAddress,
    isFetchingAddress,
    addressList,
    vendors,
    isErrorModalVisible,
    failureArray,
  } = state;

  const {
    form,
    blToFill,
    hblToFill,
    bookingToFill,
    typeAdd,
    containerToFill,
    editData,
    userData,
    isVisible,
    showHBL,
    onClose,
    classes,
    history,
    getShippingLineDimensions,
    globalCarriers,
    linkedHblVendor,
    containerSize,
    containerTypesKeyVal,
    blRegexshippingLineMap,
    containerRegexshippingLineMap,
    showContainerTriangulation,
    visibleAccessTypes,
    carrierAdvisories,
    sendWeeklyReport,
    backRoute,
    allowedDocumentTypes,
    callback,
    shippingModeToValidIncotermMapping,
  } = props;

  const {
    validateFields,
    setFieldsValue,
    getFieldDecorator,
    getFieldValue,
  } = form;

  const orgType = userData.type;

  // if user type is FF then rename customer to shipper
  const getDisplayLabelForUser = orgType === 'FF' ? 'Shipper' : 'Customer';
  const formPreviousValue = React.useRef<any>(form.getFieldsValue());
  const isManulShippingSelected = React.useRef<boolean>(false);

  const loadCustomFields = async () => {
    const response = await getCustomFields({ moduleName: 'CONTAINER_TRACKING' });
    setCustomFields(filterActiveCustomFields(response?.data));
  };

  React.useEffect(() => {
    loadCustomFields();
  }, []);

  React.useEffect(() => {
    let newAddType = getAddType();
    if (blToFill) newAddType = TrackingTypeLabel.BL;
    else if (bookingToFill) newAddType = TrackingTypeLabel.BOOKING;
    else if (hblToFill) newAddType = TrackingTypeLabel.HBL;
    if (containerToFill) newAddType = TrackingTypeLabel.CONTAINER;
    setState({ addType: newAddType });
  }, []);

  React.useEffect(() => {
    loadData(formPreviousValue.current);
  }, [addType])

  function storePreviousValue() {
    const newValuess = form.getFieldsValue();
    Object.keys(newValuess).forEach((keyId: string) => {
      if (!_.isNil(newValuess[keyId]) && newValuess[keyId] !== '') {
        formPreviousValue.current[keyId] = newValuess[keyId];
      }
    });
  }

  function getKeyLabelFromArray(inputArray): KeyLabel[] {
    if (!isValidArray(inputArray)) return [];
    return inputArray.map(item => ({
      key: item.id,
      label: item.name,
    }));
  }

  const fetchAddressList = async (destinationLocationId?: string): Promise<void> => {
    setState({ isFetchingAddress: true });
    let addressList: SEConsignorAddress[] = [];
    let selectedImportAddress;
    const response = await fetchAddresses({
      addressType: 'DESTUFFING',
      locationList: ['FACTORY'],
    });
    if (response.isSuccess) {
      addressList = response.data || [];
      if (destinationLocationId) {
        selectedImportAddress = response.data?.find(item => item.id === destinationLocationId);
      }
    } else {
      message.error(response.errorMessage);
    }
    setState({
      addressList,
      isFetchingAddress: false,
      ...(selectedImportAddress && {
        selectedImportAddress,
      }),
    });
  };

  async function loadData(previousFieldData: any) {
    if (editData) {
      const {
        customerId,
        customerName,
        internalReferenceNumber,
        blNumber,
        hblNumber,
        hblVendorName,
        containerNumber,
        shippingLineId,
        cfsFreeDays,
        detentionFreeDays,
        demurrageFreeDays,
        loadingPortCode,
        dischargePortCode,
        originPortCode,
        destinationPortCode,
        contractNumber,
        invoiceNumberList,
        blIssueDate,
        supplierId,
        supplierName,
        customerReferenceNumber,
        supplierReferenceNumber,
        movementType,
        accessorId,
        accessorType,
        shipperId,
        shipperName,
        bookingNumber,
        shipmentNumber,
        shipmentType,
        promisedTransitDays,
        promisedDateOfCompletion,
        destinationLocationId,
        documents,
        purchaseOrderNumberList,
        ffId,
        ffName,
        remarks,
      } = editData;

      if (destinationLocationId) {
        fetchAddressList(destinationLocationId);
      }
      const pgiDate = editData.pgiDate || editData.pgiDateBl || editData.pgiDateContainer;

      const sentId = getDisplayLabelForUser === 'Shipper' ? shipperId : customerId;
      const sentName = getDisplayLabelForUser === 'Shipper' ? shipperName : customerName;
      const sentType = orgType === 'FF' ? 'SHIPPER' : 'CUSTOMER';

      const newFields = {
        ...(internalReferenceNumber && { internalReferenceNumber }),
        ...((customerId || shipperId) && { [`${sentType.toLowerCase()}Id`]: sentId }),

        ...((
          blNumber ||
          blToFill ||
          (shipmentType === SHIPMENT_TYPE.BL)
        ) && { blNumber: blNumber || blToFill || shipmentNumber }),

        ...((
          hblNumber ||
          hblToFill ||
          (shipmentType === SHIPMENT_TYPE.HBL)
        ) && { hblNumber: hblNumber || hblToFill || shipmentNumber }),

        ...((
          bookingNumber ||
          bookingToFill ||
          (shipmentType === SHIPMENT_TYPE.BK)
        ) && { bookingNumber: bookingNumber || bookingToFill || shipmentNumber }),

        ...((
          containerNumber ||
          containerToFill ||
          (shipmentType === SHIPMENT_TYPE.CN)
        ) && { containerNumber: containerNumber || containerToFill || shipmentNumber }),
      };
      setDocuments(documents?.length ? documents.map((doc) => ({ ...(doc || {}), id: uuid() })) : [{ id: uuid() }]);
      setState({
        accessType: accessorType,
        originSame: Boolean(loadingPortCode && loadingPortCode === originPortCode),
        destinationSame: Boolean(dischargePortCode && dischargePortCode === destinationPortCode),
        customers: (sentId && sentName) ? [{
          org2Id: sentId,
          name: sentName,
        }] : [],
        suppliers: (supplierId && supplierName) ? [{
          org2Id: supplierId,
          name: supplierName,
        }] : [],
        vendors: (ffId && ffName) ? [{
          org2Id: ffId,
          name: ffName,
        }] : [],
      });
      const carrierId = hblVendorName ? globalCarriers.filter(item => item.type === 'HBL_VENDOR' && item.name === hblVendorName)[0].id :
        addType === SHIPMENT_TYPE.HBL ? shippingLineId : undefined;
      const fields = {
        ...newFields,
        cfsFreeDays,
        detentionFreeDays,
        demurrageFreeDays,
        contractNumber,
        supplierId: supplierId ?? undefined,
        promisedDateOfCompletion,
        promisedTransitDays,
        customerReferenceNumber,
        supplierReferenceNumber,
        ffId: ffId || undefined,
        pgiDate: pgiDate ? moment(pgiDate) : undefined,
        blIssueDate: blIssueDate ? moment(blIssueDate) : undefined,
        shippingLine: shippingLineId,
        movementType: movementType || MOVEMENT_TYPES.EXPORT,
        hblVendor: carrierId,
        accessType: accessorType,
        teamIds: editData?.teamDetails?.map(obj => obj.teamId.toString()),
        invoiceNumberList: invoiceNumberList || [],
        purchaseOrderNumberList: purchaseOrderNumberList || [],
        remarks: remarks || undefined,
      };
      setFieldsValue(fields);
      return;
    } else {
      const cpyValues = {...previousFieldData};
      if (
        (addType === TrackingTypeLabel.BOOKING) &&
        isManulShippingSelected.current
      ) {
        cpyValues.shippingLine=undefined;
        cpyValues.pol=undefined;
        cpyValues.pod=undefined;
        cpyValues.originPort=undefined;
        cpyValues.destinationPort=undefined;
        cpyValues.etaPod=undefined;
        cpyValues.etaDestinationPort=undefined;
      }
      form.setFieldsValue(cpyValues);
    }

    if (blToFill) validateRegexAndSetField(blToFill);
    else if (bookingToFill) validateRegexAndSetField(bookingToFill);
    else if (hblToFill) validateRegexAndSetField(hblToFill);
    else if (containerToFill) validateContainerRegexAndSetField(containerToFill);
  }

  function getAddType(): TrackingTypeLabel {
    switch (typeAdd) {
      case SHIPMENT_TYPE.CONTAINER: return TrackingTypeLabel.CONTAINER;
      case SHIPMENT_TYPE.BL: {
        if (editData?.trackingType === SHIPMENT_TYPE.BK) return TrackingTypeLabel.BOOKING;
        return TrackingTypeLabel.BL;
      }
      case SHIPMENT_TYPE.HBL: {
        return TrackingTypeLabel.HBL;
      }
      default: {
        if (
          editData?.hblNumber &&
          editData?.trackingType === SHIPMENT_TYPE.HBL
        ) return TrackingTypeLabel.HBL;
        if (
          editData?.bookingNumber &&
          editData?.trackingType === SHIPMENT_TYPE.BK
        ) return TrackingTypeLabel.BOOKING;
        if (
          editData?.containerNumber ||
          editData?.shipmentType === SHIPMENT_TYPE.CN
        ) return TrackingTypeLabel.CONTAINER;
        return TrackingTypeLabel.BL;
      }
    }
  }

  function getShipmentNumber(data: CardData) {
    switch (typeAdd) {
      case SHIPMENT_TYPE.CONTAINER: return data.containerNumber;
      case SHIPMENT_TYPE.BL: return data.blNumber;
      default: return data.bookingNumber;
    }
  }


  const getIntialSelectValues = (params: {
    editDataCode: string;
    editDateLabelKey: string;
    formKey: string;
  }): undefined | { key: string; label: string } => {
    if (editData && editData[params.editDataCode])
      return {
        key: editData[params.editDataCode],
        label: editData[params.editDateLabelKey],
      };
    if (formPreviousValue.current && formPreviousValue.current[params.formKey])
      return {
        key: formPreviousValue.current[params.formKey].code,
        label: formPreviousValue.current[params.formKey].label || '',
      };
    return undefined;
  };


  function isSupplierFieldDisabled(entity): boolean {
    const movementType = getFieldValue('movementType');
    if (movementType === MOVEMENT_TYPES.TRADE) return false;
    let disabled = true;
    if (entity === ENTITIES.SUPPLIER) disabled = (movementType !== MOVEMENT_TYPES.IMPORT);
    else if (entity === ENTITIES.CUSTOMER) disabled = false;
    return disabled;
  }

  function isEdit(checkForTrackingFailure = false): boolean {
    // return Boolean(editData);
    if (!!editData?.isManuallyTracked) return false;
    const firstCheck = Boolean(!!editData && checkForTrackingFailure);
    if (firstCheck) {
      const isTrackingPresent = editData?.isInfoPresent || editData?.isTrackingPresent;
      const isTrackingFailed = editData?.isInfoFetchFailed || editData?.isTrackingFailed;
      return Boolean(isTrackingPresent && !isTrackingFailed);
    }
    return firstCheck;
  }
  async function searchTeams() {
    setState({ isSearching: true });
    const response = await fetchAllTeams({ adminTeamRestriction: true });
    const filteredTeams = (response?.data || [])?.filter(team => team.organisation_id === props.organisationId);
    setState({ teamOptions: getKeyLabelFromArray(filteredTeams), isSearching: false });
  }

  function onModalOk() {
    setState({ isSaving: true });
    validateFields(async (err, values) => {
      const isDocumentEmpty = documentList.some((item) => (!item.type && item.url) || (!item.url && item.type));
      if (err || isDocumentEmpty) {
        setState({ isSaving: false });
        return;
      }
      if (editData) LogRocket.track('CT Tracking Edited');
      else LogRocket.track('CT Track Single Shipment');
      if (values?.movementType === MOVEMENT_TYPES.IMPORT && isEmpty(selectedImportAddress) && showContainerTriangulation) {
        message.error('Please select import address');
        setState({ isSaving: false });
        return;
      }
      await sendData(values);
      callback && callback();
    });
  }

  function getNumber(inputNumber): number | undefined {
    if (!isValidNumber(inputNumber)) return;
    return +inputNumber;
  }

  function getTrackingType() {
    switch (addType) {
      case 'Booking': return SHIPMENT_TYPE.BK;
      case 'Container': return SHIPMENT_TYPE.CN;
      case 'HBL': return SHIPMENT_TYPE.HBL;
      case 'BL':
      default: return SHIPMENT_TYPE.BL;
    }
  }
  async function sendData(data) {
    let response;
    const newData = {
      ...(editData || {}),
      ...data,
      originCountryCode: originCountry,
      destinationCountryCode: destinationCountry,
      blReceived: editData?.blReceived,
      pod: data?.pod?.key,
      pol: data?.pol?.key,
      customerId: data?.customerId || null,
      supplierId: data?.supplierId || null,
      shipperId: data?.shipperId || null,
      cfsFreeDays: getNumber(data?.cfsFreeDays),
      demurrageFreeDays: getNumber(data?.demurrageFreeDays),
      detentionFreeDays: getNumber(data?.detentionFreeDays),
      promisedTransitDays: getNumber(data?.promisedTransitDays),
      etaPod: data?.etaPod?.format('YYYY-MM-DD'),
      blIssueDate: data?.blIssueDate?.format('YYYY-MM-DD'),
      pgiDate: data?.pgiDate?.format('YYYY-MM-DD'),
      etaDestinationPort: data?.etaDestinationPort?.format('YYYY-MM-DD'),
      destinationPort: data?.destinationPort?.key,
      originPort: data?.originPort?.key,
      trackingType: getTrackingType(),
      autoFillProduct: data.autoFillProduct,
      productDetailIds: data.productDetailIds,
      destinationLocationId: data?.movementType === MOVEMENT_TYPES.IMPORT ? selectedImportAddress?.id : undefined,
      documents: documentList?.filter(item => item.url),
      purchaseOrderNumberList: data.purchaseOrderNumberList,
      shipmentOwner: shipmentOwnerSelected,
      ffId: data?.ffId || null,
    };
    // Only touch customFields when this org actually has CT custom fields loaded;
    // otherwise preserve the previous "don't send" behaviour so we never wipe data.
    if (customFields.length) {
      const customFieldValues = customFields.reduce((acc, field) => {
        acc[field.dbKey] = getFieldValue(`customFields[${field.dbKey}]`);
        return acc;
      }, {} as Record<string, string>);
      newData.customFields = buildCustomFieldsPayload(customFieldValues);
    } else {
      newData.customFields = undefined;
    }
    const trackingType = getTrackingType();
    newData.containerNumber = trackingType === 'HBL' ? undefined : newData?.containerNumber;
    if (editData) newData.id = editData?.shipmentId || editData?.id;
    if (editData) {
      response = await editShipment({
        ...newData,
        blNumbers: newData.blNumber ? [newData.blNumber] : [],
        hblNumbers: newData.hblNumber ? [newData.hblNumber] : [],
        containerNumbers: newData.containerNumber ? [newData.containerNumber] : [],
        bookingNumbers: newData.bookingNumber ? [newData.bookingNumber] : [],
      });
    } else {
      if ([SHIPMENT_TYPE.HBL, SHIPMENT_TYPE.BL].includes(addType)) {
        response = await quickAddBL({ trackingType, shipmentNumberList: [newData] });
      } else if (addType === 'Booking') {
        response = await quickAddBL({ trackingType, shipmentNumberList: [newData] });
      } else {
        response = await quickAddContainer({
          trackingType, shipmentNumberList: [{
            ...newData,
            containerNumbers: [newData.containerNumber],
          }]
        });
      }
    }
    setState({ isSaving: false });
    if (response.isSuccess) {
      if (response?.data?.failureArray?.length) {
        setState({
          isErrorModalVisible: true,
          failureArray: response.data.failureArray,
        });
        const action = 'BL addition failed';
        sendEvent(
          EventCategories.BL_ADDITION,
          action,
          `${data.shippingLine}_${data.blNumber}`,
          1,
        );
        sendIntercomEvent(
          action,
          { eventCategory: EventCategories.BL_ADDITION, ...data },
        );
        return;
      }
      sendIntercomEvent(
        'Shipment added - Create shipment -new tracking-single shipment',
        { eventCategory: EventCategories.BL_ADDITION, ...data },
      );
      sendEvent(
        EventCategories.BL_ADDITION,
        'Shipment added - Create shipment - new tracking-single shipment',
        `${data.shippingLine}_${data.blNumber}`,
        1,
      );
      if (checkShippingLineManualOrNot() && !isEdit()) {
        const { shipmentId, shipmentType } = response?.data?.result[0] || {};
        const shipmentTypeSecond = (response?.data?.result[1] || {})?.shipmentType;
        const shippingLine = getShippingLineDimensions
          .find(item => item.id === data.shippingLine);
        onClose({
          shipmentId,
          shipmentType,
          shippingLine,
          shipmentTypeSecond,
          isSuccess: true,
          movementType: data.movementType,
          accessType: data.accessType,
          teamSelected: data.teamIds,
          shipmentNumber: getShipmentNumber(data),
        });
      } else {
        onClose({ isSuccess: true });
      }
      const successMsg = `${addType} ${editData ? 'Updated' : 'Added'} successfully`;
      LogRocket.track(successMsg);
      message.success(successMsg, 3.5);
      if (backRoute) {
        history.push(backRoute, { ...history?.location?.state });
      } else if (typeAdd === SHIPMENT_TYPE.SHIPMENT) {
        history.push(getContainerTrackingRoute(null, 'shipment'));
      } else if (typeAdd === SHIPMENT_TYPE.HBL) {
        history.push(getContainerTrackingRoute(null, 'hbl'));
      } else if (addType === 'Container') {
        history.push(getContainerTrackingRoute(null, 'container'));
      } else {
        history.push(getContainerTrackingRoute(null, 'bl'));
      }
    } else {
      message.error(response.errorMessage);
    }
  }

  const generateOptionsFromList = (items) => {
    if (!items || !items.length) return [];
    const optionsList = items.map(element =>
      <Option
        key={element.id}
        value={element.id}
        data-value={element.name}
      >
        <div className={classes.spaceBetween}>
          {element.name}
          {!element.isTrackingEnabled && <Tag color="cyan">Manual</Tag>}
        </div>
      </Option>,
    );
    return optionsList;
  };

  function validateRegexAndSetField(str: string) {
    let text = str;
    if (!text || text.length < 2) return;
    text = text.trim().toUpperCase();
    const keys = Object.keys(blRegexshippingLineMap || {}) || [];
    for (let i = 0; i < keys.length; i = i + 1) {
      if (text.match(keys[i])) {
        form.setFieldsValue({
          shippingLine: blRegexshippingLineMap[keys[i]],
        });
        return;
      }
    }
  }

  function validateContainerRegexAndSetField(str: string) {
    let text = str;
    if (!text || text.length < 2) return;
    text = text.trim().toUpperCase();
    const keys = Object.keys(containerRegexshippingLineMap || {}) || [];
    for (let i = 0; i < keys.length; i = i + 1) {
      if (text.match(keys[i])) {
        form.setFieldsValue({ shippingLine: containerRegexshippingLineMap[keys[i]] });
        return;
      }
    }
  }

  function handleFocus(entity) {
    const val = getFieldValue('organisationId');
    if (!val) handleSearch('', entity);
  }

  let searchTimer: ReturnType<typeof setTimeout> | null = null;

  async function handleSearch(value, entity) {
    let stakeholer: string;
    if (entity === 'CUSTOMER' || entity === 'SHIPPER') {
      stakeholer = 'customers';
    } else if (entity === 'FF') {
      stakeholer = 'vendors';
    } else {
      stakeholer = 'suppliers';
    }
    if (searchTimer) {
      clearTimeout(searchTimer);
      searchTimer = null;
    }
    setState({ searching: true });
    searchTimer = setTimeout(async () => {
      const params = { type: entity, queryString: value };
      const response = await searchStakeholder(params);
      setState({ searching: false });
      if (response.isSuccess) {
        setState({
          [stakeholer]: response.data || [],
        });
      }
    }, 300);
  }

  const formItemLayout = {
    labelCol: { sm: { span: 8 }, lg: { span: 6 } },
    wrapperCol: { sm: { span: 15 }, lg: { span: 10 } },
  };

  const movementLabel = () => {
    return <div
      className={classes.hintHeader}>
      Movement Type
      <span className={classes.required}>
        *
      </span>
    </div>;
  };

  function handleChangeMovementType(e) {
    if (orgType !== 'SHIPPER') return;
    if (e.target.value === MOVEMENT_TYPES.IMPORT) {
      setFieldsValue({
        customerId: undefined,
        customerReferenceNumber: undefined,
      });
    } else if (e.target.value === MOVEMENT_TYPES.EXPORT) {
      setFieldsValue({
        supplierId: undefined,
        supplierReferenceNumber: undefined,
      });
    }
  }

  const renderAddressSelection = (): React.ReactElement => {
    return (
      <React.Fragment>
        {!isEmpty(selectedImportAddress) && (
          <div
            className={classes.selectedAddress}
            style={{ border: '1px solid #CCCCCC', cursor: 'default' }}
          >
            <div className={classes.addressHeading}>{selectedImportAddress?.name}</div>
            <div className={classes.addressOtherDetails}>{getFormattedAddress(selectedImportAddress)}</div>
          </div>
        )}
        <div
          className={classes.selectAddress}
          style={{ marginTop: '2px' }}
          onClick={() => setState({ isSelectAddressModalVisible: true })}
        >
          {isFetchingAddress ?
            <Spin size="small" />
            :
            (!isEmpty(selectedImportAddress) ? 'Change Address' : '+ Select Address*')
          }
        </div>
      </React.Fragment>
    );
  };

  const renderMovementType = () => {
    const movementType = getFieldValue('movementType');
    return <Col span={12}>
      <FormItem
        labelCol={formItemLayout.labelCol}
        colon={false}
        label={movementLabel()}
        required={false}
      >
        {getFieldDecorator('movementType', {
          rules: [{ required: true, message: 'Movement type is required' }],
          initialValue: movementType || MOVEMENT_TYPES.EXPORT,
        })(<Radio.Group
          onChange={e => handleChangeMovementType(e)}>
          {Object.keys(MOVEMENT_TYPES).map(type =>
            <Radio
              value={type}>
              {prettifyString(type)}
            </Radio>)}
        </Radio.Group>)}
      </FormItem>
      {getFieldValue('movementType') === MOVEMENT_TYPES.IMPORT && showContainerTriangulation && <React.Fragment>
        <Col {...formItemLayout.labelCol} />
        <Col sm={15} lg={12} style={{ margin: '-15px 0 22px 0', paddingLeft: 0 }}>
          {renderAddressSelection()}
        </Col>
      </React.Fragment>}
    </Col>;
  };

  const renderInternal = () => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>Internal Number</div>}>
        {getFieldDecorator('internalReferenceNumber', {
        })(<Input
          placeholder="Internal Number"
          style={{ width: '100%' }}
        />)}
      </FormItem>
    </Col>;
  };

  const renderPurchaseOrderNumber = () => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>Purchase Order <br/> Number</div>}>
        {getFieldDecorator('purchaseOrderNumberList', {
          initialValue: editData?.purchaseOrderNumberList || [],
        })(<Select
          mode="tags"
          placeholder="Purchase Order Number"
          style={{ width: '100%' }}
          notFoundContent={null}
        />)}
      </FormItem>
    </Col>;
  };

  const renderAddMovementTypeAndCode = () => {
    return <Row gutter={24}>
      {renderMovementType()}
      {renderInternal()}
    </Row>;
  };

  const renderDropdown = (menu: React.ReactElement, selectLabel: string, key: string) => {
    if (searching) return menu;
    return <div
      style={{ border: '1px solid rgba(0, 0, 0, 0.15)' }}>
      {menu}
      <div
        className={classes.dropdownStyle}
        onMouseDown={(e) => {
          stops(e);
          setState({ [key]: true });
        }}>
        <Icon type="plus" style={{ marginRight: '10px' }} />
        Add {selectLabel}
      </div>
    </div>;
  };

  const getCustomerLabel = (item) => {
    if (item?.stakeholderCode) {
      return `${item.name} (${item.stakeholderCode})`;
    }
    return item.name;
  }

  const renderOrgOptions = (inputArray): React.ReactElement[] => {
    if (!isValidArray(inputArray)) return [];
    return inputArray.map(item => {
      return (
        <Select.Option
          {...item}
          key={item.org2Id}>
          <Tooltip placement="right" title={getCustomerLabel(item)}>
            {getCustomerLabel(item)}
          </Tooltip>
        </Select.Option>
      )
    })
  };

  function setProduct(key?, options?) {
    let {
      customerProduct,
      shipperProduct,
      supplierProduct,
    } = state;

    let existing: KeyLabel[] = form.getFieldValue('productDetailIds') || [];

    if (key === 'customerProduct') {
      customerProduct = (options || customerProduct);
    } else if (key === 'shipperProduct') {
      shipperProduct = (options || shipperProduct);
    } else if (key === 'supplierProduct') {
      supplierProduct = (options || supplierProduct);
    } else { }

    const productDetailIds = getUniqFromArray([
      ...(customerProduct || []),
      ...(shipperProduct || []),
      ...(supplierProduct || []),
    ], 'key');

    existing = existing.filter(item => !(productDetailIds.includes(item)));

    form.setFieldsValue({
      productDetailIds: getUniqFromArray([
        ...productDetailIds,
        ...(existing || []),
      ], 'key'),
    });
  }

  function handleProductPrefill(values, key: string) {
    const { productDetails } = values || {};
    const options = [...(productDetails || [])].filter(item => (item.status === 'ACTIVE'))
      .map(item => ({
        key: item.id,
        label: item.internalName,
      }));

    setState({
      [key]: options,
    });

    const shouldFill = form.getFieldValue('autoFillProduct');
    if (shouldFill) {
      setProduct(key, options);
    }
  }

  const renderCustomer = () => {
    const searchType = orgType === 'FF' ? 'SHIPPER' : 'CUSTOMER';
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>{getDisplayLabelForUser}</div>}>
        {getFieldDecorator(`${searchType.toLowerCase()}Id`, {
        })(<Select
          showSearch
          allowClear
          onChange={key => handleProductPrefill(
            customers.find(item => key === item.org2Id),
            `${searchType.toLowerCase()}Product`
          )}
          placeholder={`Select ${getDisplayLabelForUser}`}
          disabled={orgType === 'SHIPPER' && isSupplierFieldDisabled(searchType)}
          onSearch={val => handleSearch(val, searchType)}
          onFocus={() => handleFocus(searchType)}
          filterOption={(inputValue, option) => true}
          notFoundContent={renderLoading(searching)}
          dropdownRender={menu => renderDropdown(
            menu, getDisplayLabelForUser, 'isAddCustomerModal')}
          style={{ width: '100%', marginBottom: '5px' }}>
          {renderOrgOptions(customers)}
        </Select>,
        )}
      </FormItem>
    </Col>;
  };

  const renderSupplier = () => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>Supplier</div>}>
        {getFieldDecorator('supplierId', {
        })(<Select
          allowClear
          showSearch
          onChange={key => handleProductPrefill(suppliers.find(item => key === item.org2Id), 'supplierProduct')}
          placeholder="Select Supplier"
          disabled={isSupplierFieldDisabled(ENTITIES.SUPPLIER)}
          onSearch={val => handleSearch(val, ENTITIES.SUPPLIER)}
          onFocus={() => handleFocus(ENTITIES.SUPPLIER)}
          filterOption={(inputValue, option) => true}
          notFoundContent={renderLoading(searching)}
          dropdownRender={menu => renderDropdown(menu, 'Supplier', 'isAddSupplierModal')}
          style={{ width: '100%', marginBottom: '5px' }}>
          {renderOrgOptions(suppliers)}
        </Select>,
        )}
      </FormItem>
    </Col>;
  };

  const renderVendor = () => {
    if (orgType !== 'SHIPPER' || addType === TrackingTypeLabel.HBL) return;
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>Freight Forwarder (FF)</div>}>
        {getFieldDecorator('ffId', {
        })(<Select
          allowClear
          showSearch
          placeholder="Select FF"
          onSearch={val => handleSearch(val, ENTITIES.FF)}
          onFocus={() => handleFocus(ENTITIES.FF)}
          filterOption={(inputValue, option) => true}
          notFoundContent={renderLoading(searching)}
          dropdownRender={menu => renderSelectDropDown(menu, searching)}
          style={{ width: '100%', marginBottom: '5px' }}>
          {renderOrgOptions(vendors)}
        </Select>,
        )}
      </FormItem>
    </Col>;
  };

  const customerLabel = () => {
    return <div className={classes.hintHeader}>
      <div>
        {getDisplayLabelForUser} Reference <br/> Number
      </div>
    </div>;
  };

  const renderCustomerReferenceNumber = () => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={customerLabel()}>
        {getFieldDecorator('customerReferenceNumber', {
        })(<Input
          disabled={orgType === 'SHIPPER' && isSupplierFieldDisabled(ENTITIES.CUSTOMER)}
          placeholder={`${getDisplayLabelForUser} Reference number`}
          style={{ width: '100%' }} />)
        }
      </FormItem>
    </Col>;
  };

  const renderCustomerDetails = () => {
    return <Row gutter={24}>
      {renderCustomer()}
      {orgType === 'SHIPPER' ?
        renderSupplier() :
        renderCustomerReferenceNumber()}
    </Row>;
  };

  const supplierLabel = () => {
    return <div
      className={classes.hintHeader}>
      <div>
        Supplier Reference <br/> Number
      </div>
    </div>;
  };

  const renderSupplierCustomer = () => {
    if (orgType !== 'SHIPPER') return null;
    return <Row gutter={24}>
      {renderCustomerReferenceNumber()}
      {renderSupplierReference()}
    </Row>;
  };

  const renderSupplierReference = () => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={supplierLabel()}>
        {getFieldDecorator('supplierReferenceNumber', {
        })(<Input
          disabled={isSupplierFieldDisabled(ENTITIES.SUPPLIER)}
          placeholder="Supplier Reference number"
          style={{ width: '100%' }}
        />)
        }
      </FormItem>
    </Col>;
  };

  const renderSupplierFields = () => {
    return <React.Fragment>
      {renderCustomerDetails()}
      {renderSupplierCustomer()}
    </React.Fragment>;
  };

  const renderDemurrageDetails = () => {
    return <Collapse bordered={false} className={classes.collapse}
      defaultActiveKey={isEdit() ? ['1'] : undefined}>
      <Collapse.Panel
        key="1"
        header={<span className={classes.moreDetails}>
          Demurrage and Detention Details
        </span>}>
        {renderDemurrageDetention()}
        <Row gutter={24}> {getDaysInput('cfsFreeDays', 'CFS Free Days')}</Row>
      </Collapse.Panel>
    </Collapse>;
  };

  const renderAddMore = () => {
    return (
      <a
        style={{ marginLeft: '12%', fontSize: '12px', width: '10%' }}
        onClick={() => handleAddMore()}
      >
        <Icon type="plus" />
        Add More
      </a>
    );
  };

  const handleAddMore = () => {
    setDocuments(prevState => ([
      ...prevState,
      { id: uuid() }
    ]));
  };

  const handleDocumentChange = (doc: Document) => {
    setDocuments(prevState => prevState.map((item) => {
      if (doc.id === item.id) return doc;
      return item;
    }));
  };

  const removeUpload = (id: string) => {
    setDocuments(prevState => prevState.map((item) => {
      if (item.id === id) {
        return {
          id: item.id,
          type: item.type,
        };
      }
      return item;
    }));
  };

  const handleRemoveDocument = (id: string) => {
    setDocuments(prevState => [...prevState.filter((doc) => doc.id !== id)]);
  };

  const renderDocumentsFields = () => {
    return (
      <div style={{ paddingLeft: 14, display: 'flex', flexDirection: 'column' }}>
        {documentList?.map((doc: Document, idx: number) => (
          <SelectDocuments
            form={form}
            style={{ marginTop: 6, marginBottom: 10 }}
            document={doc}
            showLabel={idx === 0}
            allowedDocumentTypes={allowedDocumentTypes}
            onChange={handleDocumentChange}
            showDelete={documentList?.length !== 1}
            removeUpload={() => removeUpload(doc.id)}
            handleRemove={() => handleRemoveDocument(doc.id)}
            additionalStyles={{
              labelStyles: { width: '12%' },
              errorStyles: { marginLeft: '12%' },
              selectStyles: { width: 200 },
            }}
          />
        ))}
        {renderAddMore()}
      </div>
    );
  };

  const renderDocumentDetails = () => {
    return (
      <Collapse
        bordered={false}
        className={classes.collapse}
        defaultActiveKey={isEdit() ? ['1'] : undefined}
      >
        <Collapse.Panel
          key="1"
          header={<span className={classes.moreDetails}>
            Document
          </span>}
        >
          {renderDocumentsFields()}
        </Collapse.Panel>
      </Collapse>
    );
  };

  const renderDemurrageDetention = () => {
    return <Row gutter={24}>
      {getDaysInput('demurrageFreeDays', 'Demurrage Free Days')}
      {getDaysInput('detentionFreeDays', 'Detention Free Days')}
    </Row>;
  };

  const getDaysInput = (key: string, label: string) => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>{label}</div>}>
        {getFieldDecorator(key, {
          rules: [NumberRule],
          initialValue: editData && editData[key],
        })(<Input style={{ width: '100%' }}
          placeholder={label}
          min={0}
        />,
        )}
      </FormItem>
    </Col>;
  };

  const renderInvoiceNumber = () => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>Invoice Number</div>}>
        {getFieldDecorator('invoiceNumberList', {
          initialValue: editData?.invoiceNumberList || [],
        })(<Select
          mode="tags"
          notFoundContent={null}
          style={{ width: '100%' }}
          placeholder="Invoice Number"
        />,
        )}
      </FormItem>
    </Col>;
  };

  const renderContractDetails = () => {
    return <Col span={12}>
      <FormItem {...formItemLayout} colon={false}
        label={<div className={classes.hintHeader}>Contract Number</div>}>
        {getFieldDecorator('contractNumber', {
          rules: [{ ...alphaNumericWithSpecialChars }],
        })(
          <Input
            style={{ width: '100%' }}
            placeholder="Contract Number"
          />,
        )}
      </FormItem>
    </Col>;
  };

  const renderBLIssueDate = () => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>BL Issue Date</div>}>
        {getFieldDecorator('blIssueDate', {
        })(<DatePicker
          placeholder="BL Issue Date"
          popupStyle={{ zIndex: 1060 }}
          style={{ width: '100%' }}
          format="DD/MM/YYYY" />)}
      </FormItem>
    </Col>;
  };

  const renderPgiDate = () => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>PGI Date</div>}>
        {getFieldDecorator('pgiDate', {
        })(<DatePicker
          placeholder="PGI Date"
          popupStyle={{ zIndex: 1060 }}
          style={{ width: '100%' }}
          format="DD/MM/YYYY" />)}
      </FormItem>
    </Col>;
  };

  const renderRemarks = () => {
    return (
      <Col span={12}>
        <FormItem
          {...formItemLayout}
          colon={false}
          label={<div className={classes.hintHeader}>Remarks</div>}>
          {getFieldDecorator('remarks', {
            rules: [
              { max: 500, message: 'Max length: 500' },
            ],
          })(<TextArea
            rows={2}
            style={{ width: '100%' }}
            placeholder="Remarks"
          />)}
        </FormItem>
      </Col>
    );
  };

  const renderBLForContainer = () => {
    if (addType !== 'Container') return null;

    return <Col span={12}>
      <FormItem {...formItemLayout} colon={false}
        label={<div className={classes.hintHeader}>
          Linked BL Number
        </div>}>
        {getFieldDecorator('linkedBlNumber', {
          initialValue: editData?.linkedBlNumber,
          rules: [
            { max: 25, message: 'Max length: 25' },
            { pattern: /^[^\s]+$/, message: 'No whitespace allowed' },
          ],
        })(
          <Input
            onChange={e => validateRegexAndSetField(e.target.value)}
            placeholder="Linked BL Number"
          />,
        )}
      </FormItem>
    </Col>;
  }

  const renderAdditionalInfo = () => {
    return <Collapse
      bordered={false}
      className={classes.collapse}
      defaultActiveKey={isEdit() ? ['1'] : undefined}
    >
      <Collapse.Panel
        header={<span className={classes.moreDetails}>
          Additional Details</span>} key="1">
        <Row gutter={24}>
          {renderInvoiceNumber()}
          {renderContractDetails()}
        </Row>
        <Row gutter={24}>
          {renderBLIssueDate()}
          {getDaysInput('promisedTransitDays', 'Promised Transit Days')}
        </Row>
        <Row gutter={24}>
          {renderPgiDate()}
          {renderBLForContainer()}
        </Row>
        <Row gutter={24}>
          {renderRemarks()}
        </Row>
        {renderCustomFields()}
      </Collapse.Panel>
    </Collapse>;
  };

  const renderCustomFields = () => {
    if (!customFields.length) return null;
    return (
      <Row gutter={24}>
        {customFields.map((field) => (
          <Col span={12} key={field.dbKey}>
            <FormItem
              {...formItemLayout}
              colon={false}
              label={<div className={classes.hintHeader}>
                {field.description || field.name}
              </div>}
            >
              {getFieldDecorator(`customFields[${field.dbKey}]`, {
                initialValue: getCustomFieldInitialValue(editData, field.dbKey),
                rules: [{ max: 500, message: 'Max length: 500' }],
              })(
                <Input placeholder={field.description || field.name} />,
              )}
            </FormItem>
          </Col>
        ))}
      </Row>
    );
  };

  function handleChecboxChange(flag, field, state, relatedField) {
    const newFields: any = {
      [field]: flag ? getFieldValue(relatedField) : undefined,
    };
    if (field === 'destinationPort') {
      newFields.etaPod = flag ? getFieldValue('etaDestinationPort') : undefined;
    }
    setFieldsValue(newFields);
    setState({
      [state]: flag,
    });
  }

  function checkShippingLineManualOrNot() {
    const shippingLine = getFieldValue('shippingLine');
    let isManualShippingLine = false;
    if (shippingLine) {
      const shippingMasterObj = (getShippingLineDimensions || [])
        .find(item => item.id === shippingLine);
      if (shippingMasterObj && !shippingMasterObj.isTrackingEnabled) {
        isManualShippingLine = true;
      }
    }
    return isManualShippingLine;
  }

  function isPodEqualToDestinationPort() {
    const pod = getFieldValue('pod');
    const destinationPort = getFieldValue('destinationPort');
    return (pod && destinationPort && pod.key === destinationPort.key);
  }

  function isEtaDisabled() {
    return destinationSame || isPodEqualToDestinationPort();
  }

  const renderPol = () => {
    const initialValue = getIntialSelectValues({
      editDataCode: 'loadingPortCode',
      editDateLabelKey: 'loadingPortName',
      formKey: 'pol'
    });

    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>POL</div>}>
        {getFieldDecorator('pol', {
          initialValue,
        })(<SelectPort
          style={{ width: '100%' }}
          placeholder="POL"
          apiOptions={portOptions}
          onChange={(port) => {
            setFieldsValue({ 'pol': port });
            handlePortChange(port, 'originCountry');
          }}
        />)}
      </FormItem>
    </Col>;
  };

  const renderPod = () => {
    const initialValue = getIntialSelectValues({
      editDataCode: 'dischargePortCode',
      editDateLabelKey: 'dischargePortName',
      formKey: 'pod'
    });
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>POD</div>}>
        {getFieldDecorator('pod', {
          initialValue,
        })(<SelectPort
          style={{ width: '100%' }}
          apiOptions={portOptions}
          onChange={(port) => {
            setFieldsValue({ 'pod': port });
            handlePortChange(port, 'destinationCountry');
            const destinationPort = getFieldValue('destinationPort');
            if (destinationPort && port && destinationPort.key === port.key) {
              setFieldsValue({
                etaPod: getFieldValue('etaDestinationPort'),
              });
            }
          }}
          placeholder="POD"
        />)}
      </FormItem>
    </Col>;
  };

  const portOptions = {
    type: ['DRY', 'WET'],
  };

  const handlePortChange = (port: Ports, key: string) => {
    setState({
      [key]: port?.countryCode,
    });

    if (key === 'originCountry' && originSame) {
      const newFields = {
        'originPort': getFieldValue('pol'),
      };
      setFieldsValue(newFields);
    }
    if (key === 'destinationCountry' && destinationSame) {
      const newFields = {
        'destinationPort': getFieldValue('pod'),
      };
      setFieldsValue(newFields);
    }

  };

  const renderManualTrackingForm = () => {
    const isManualShippingLine = checkShippingLineManualOrNot();
    if (!isManualShippingLine) return null;

    const initialValueOriginPort = getIntialSelectValues({
        editDataCode: 'originPortCode',
        editDateLabelKey: 'originPortName',
        formKey: 'originPort'
    });

    const initialValueDestinationPort = getIntialSelectValues({
      editDataCode: 'destinationPortCode',
      editDateLabelKey: 'destinationPortName',
      formKey: 'destinationPort'
    });

    return <div className={classes.manualFormParent}>
      <Row gutter={30}>
        {renderPol()}
        {renderPod()}
      </Row>
      <Row gutter={30} style={{ marginTop: '8px' }}>
        <Col span={12}>
          <Row>
            <Col
              {...formItemLayout.labelCol}
              style={{ lineHeight: '11px' }}>
              <div className={classes.hintHeader}>Origin Port</div>
            </Col>
            <Col {...formItemLayout.wrapperCol}>
              <Checkbox style={{ marginBottom: '8px' }}
                checked={originSame}
                onChange={e => handleChecboxChange(
                  e.target.checked,
                  'originPort',
                  'originSame',
                  'pol',
                )}>
                <span style={{ color: tokens.colors.textSecondary, fontSize: tokens.fontSize.small }}>
                  Origin Same as POL
                </span>
              </Checkbox>
              <FormItem wrapperCol={{ span: 24 }} colon={false}>
                {getFieldDecorator('originPort', {
                  initialValue: initialValueOriginPort,
                })(<SelectPort
                  style={{ width: '100%' }}
                  apiOptions={portOptions}
                  disabled={originSame}
                  onChange={(port: Ports) => console.log(port)}
                  placeholder="Origin Port"
                />)}
              </FormItem>
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row>
            <Col
              {...formItemLayout.labelCol}
              style={{ lineHeight: '11px' }}>
              <div className={classes.hintHeader}>
                Destination Port
              </div>
            </Col>
            <Col {...formItemLayout.wrapperCol}>
              <Checkbox
                style={{ marginBottom: '8px' }}
                checked={destinationSame}
                onChange={e => handleChecboxChange(
                  e.target.checked,
                  'destinationPort',
                  'destinationSame',
                  'pod',
                )}>
                <span style={{ color: tokens.colors.textSecondary, fontSize: tokens.fontSize.small }}>
                  Destination Same as POD
                </span>
              </Checkbox>
              <FormItem wrapperCol={{ span: 24 }} colon={false}>
                {getFieldDecorator('destinationPort', {
                  initialValue: initialValueDestinationPort,
                })(<SelectPort
                  apiOptions={portOptions}
                  style={{ width: '100%' }}
                  disabled={destinationSame}
                  onChange={(port) => {
                    handlePortChange(port, 'destinationCountry');
                    const pod = getFieldValue('pod');
                    if (pod && port && pod.key === port.key) {
                      setFieldsValue({
                        etaPod: getFieldValue('etaDestinationPort'),
                      });
                    }
                  }}
                  placeholder="Destination Port"
                />)}
              </FormItem>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={24} style={{ marginTop: '18px' }}>
        {renderEtaPod()}
        {renderEtaDestination()}
      </Row>
      {renderContainerDetails()}
    </div>;
  };

  const renderEtaDestination = () => {
    return <Col span={12}>
      <FormItem {...formItemLayout} colon={false}
        label={<div className={classes.hintHeader}>ETA (Destination Port)</div>}>
        {getFieldDecorator('etaDestinationPort', {
          initialValue: (()=>{
            if (editData && editData.finalEta) return moment(editData.finalEta);
            if (formPreviousValue.current && formPreviousValue.current.etaDestinationPort)
              return moment(formPreviousValue.current.etaDestinationPort);
            return undefined;
          })()
        })(<DatePicker
          placeholder="Set Date"
          popupStyle={{ zIndex: 1060 }}
          onChange={(date: moment.Moment | null) => {
            if (isEtaDisabled()) {
              setFieldsValue({
                etaPod: date,
              });
            }
          }}
          style={{ width: '100%' }}
          format="DD/MM/YYYY" />)
        }
      </FormItem>
    </Col>;
  };

  const renderEtaPod = () => {
    return <Col span={12}>
      <FormItem {...formItemLayout} colon={false}
        label={<div className={classes.hintHeader}>ETA (POD)</div>}>
        {getFieldDecorator('etaPod', {
          initialValue: (() => {
            if (editData && editData?.etaPodFinal) {
              return moment(editData.etaPodFinal)
            } 
            if (formPreviousValue.current && formPreviousValue.current.etaPod) {
              return moment(formPreviousValue.current.etaPod)
            }
            return undefined;
          })(),
        })(<DatePicker
          placeholder="Set Date"
          popupStyle={{ zIndex: 1060 }}
          style={{ width: '100%' }}
          format="DD/MM/YYYY"
          disabled={isEtaDisabled()} />)
        }
      </FormItem>
    </Col>;
  };

  const renderContainerDetails = () => {
    if (addType !== 'Container') return null;
    return <Row gutter={30}>
      <Col span={12}>
        <Row>
          {renderContainerLabel()}
          <Col {...formItemLayout.wrapperCol}>
            <Row gutter={10}>
              {renderContainerType()}
              {renderContainerSize()}
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>;
  };

  const renderContainerLabel = () => {
    return <Col
      {...formItemLayout.labelCol}>
      <div
        className={classes.hintHeader}
        style={{ paddingTop: '10px' }}>
        Container Details
      </div>
    </Col>;
  };

  const renderContainerType = () => {
    return <Col span={14}>
      <FormItem wrapperCol={{ span: 24 }} colon={false}>
        {getFieldDecorator('containerType', {
          initialValue: editData?.containerType,
        })(<Select
          allowClear
          placeholder="Type"
          style={{ width: '100%' }}>
          {containerTypesKeyVal.map(type =>
            <Select.Option key={type.key}>
              {type.label}
            </Select.Option>)}
        </Select>)}
      </FormItem>
    </Col>;
  };

  const renderContainerSize = () => {
    return <Col span={10}>
      <FormItem
        wrapperCol={{ span: 24 }}
        colon={false}>
        {getFieldDecorator('containerSize', {
          initialValue: editData?.containerSize,
        })(<Select
          allowClear
          placeholder="Size"
          style={{ width: '100%' }}>
          {containerSize.map(size =>
            <Select.Option key={size}>
              {size}
            </Select.Option>)}
        </Select>)}
      </FormItem>
    </Col>;
  };

  React.useEffect(() => {
    setState({ isSearching: true });
    searchTeams();
  }, []);

  const renderOptions = (inputArray): React.ReactElement[] => {
    if (!isValidArray(inputArray)) return [];
    return inputArray.map(elem => <Option
      {...elem}
      key={elem.key}>
      {elem.label}
    </Option>);
  };

  const renderLoading = (searching: boolean) => {
    if (searching) {
      return <Spin style={{ marginLeft: '45%', marginTop: '10%' }} />;
    }
    return 'Not Found';
  };

  const renderAccessTypes = {
    TEAM: (<><Icon type="team" /> Team</>),
    PUBLIC: (<><Icon type="global" /> Workplace</>),
    PRIVATE: (<><Icon type="user" /> Private</>),
  };

  const renderAccessType = () => {
    return <FormItem>
      {getFieldDecorator('accessType', {
        rules: [{ required: true, message: 'Access type is required' }]
      })(
        <Select
          style={{ width: '230px' }}
          placeholder="Select Access"
          onSelect={value => setState({ accessType: value })}
        >
          {defaultAccessKeys?.map((item) => {
            return (
              <Select.Option
                key={item}
                disabled={
                  (!!visibleAccessTypes.length && !visibleAccessTypes.includes(item)) ||
                  (item === 'TEAM' && teamOptions && !teamOptions.length)
                }
              >
                {renderAccessTypes[item]}
              </Select.Option>
            );
          })}
        </Select>
      )}
    </FormItem>;
  };

  const renderAccessDetails = () => {
    return (
      <Col span={12} style={{ display: 'flex', flexDirection: 'column' }}>
        <div>
          <Col span={6} style={{ padding: 0 }}>
            <div className={classes.hintHeader}>
              Access
              <span className={classes.required}>*</span>
            </div>
          </Col>
          <Col span={10} style={{ padding: 0 }}>
            {renderAccessType()}
          </Col>
          <Col span={8} className={classes.accessInfo}>
            {accessType && ACCESS_TYPE_TEXT[accessType]}
          </Col>
        </div>
        {renderTeamField()}
      </Col>
    );
  };

  const renderTeamField = () => {
    if (accessType !== 'TEAM') return null;
    return <Row gutter={24} style={{ paddingBottom: '20px' }}>
      <Col span={5} offset={4} style={{ paddingLeft: '55px' }}>
        <FormItem colon={false} className={classes.teamFIeld}>
          {getFieldDecorator('teamIds', {
            rules: [{ required: true, message: 'Cannot be empty!' }],
            initialValue: editData?.teamDetails ? editData?.teamDetails.map(obj => obj.teamId.toString()) : undefined,
          })(
            <Select
              mode="multiple"
              allowClear
              showSearch
              showArrow
              optionFilterProp="children"
              placeholder="Select Team"
              style={{ width: '230px' }}
              dropdownRender={menu => isSearching ?
                <Spin style={{ marginLeft: '45%', marginTop: '20%' }} /> : menu}
            >
              {renderOptions(teamOptions)}
            </Select>,
          )}
        </FormItem>
      </Col>
    </Row>;
  };

  const renderShipmentOwnerAndPurchaseOrder = () => {
    return (
      <Row gutter={24}
        style={{ paddingBottom: '10px' }}>
        {renderShipmentOwnerSearch()}
        {renderPurchaseOrderNumber()}
      </Row>
    )
  }

  const renderAccessTypeAndVendor = () => {
    return (
      <Row gutter={24}
        style={{ paddingBottom: '10px' }}
      >
        {renderAccessDetails()}
        {renderVendor()}
      </Row>
    );
  };

  const renderButton = () => {
    return <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button
        type="primary"
        style={{
          height: 38,
          backgroundColor: tokens.colors.primary,
          border: tokens.colors.primary,
          borderRadius: tokens.radius.md,
          textShadow: 'none',
        }}
        loading={isSaving}
        onClick={onModalOk}>
        {editData ? 'Update Tracking' : 'Start Tracking'}
      </Button>
    </div>;
  };

  const renderRadioGroup = () => {
    return <Radio.Group
      style={{ marginBottom: 32 }}
      disabled={Boolean(editData)}
      onChange={e => {
        setState({ addType: e.target.value });
        storePreviousValue();
      }}
      value={addType}>
      <Radio.Button className={classes.radio} value={'BL'}>
        BL
      </Radio.Button>
      <Radio.Button className={classes.radio} value={'Container'}>
        Container
      </Radio.Button>
      <Radio.Button className={classes.radio} value={'Booking'}>
        Booking
      </Radio.Button>
      {showHBL && <Radio.Button className={classes.radio} value={'HBL'}>
        HBL
      </Radio.Button>}
    </Radio.Group>;
  };

  const containerLabel = () => {
    return <div
      className={classes.hintHeader}>
      Container Number
      <span className={classes.required}>
        *
      </span>
    </div>;
  };

  function getContainerInitialValue(): string {
    let containerNumber = editData?.containerNumber;
    containerNumber = containerNumber || containerToFill;
    if (
      editData?.trackingType === SHIPMENT_TYPE.CN ||
      editData?.shipmentType === SHIPMENT_TYPE.CN
    ) {
      containerNumber = containerNumber || editData?.shipmentNumber;
    }
    return containerNumber;
  }

  function getHBLInitialValue(): string {
    if (editData?.shipmentType === SHIPMENT_TYPE.HBL) {
      return editData?.shipmentNumber;
    }
    return editData?.hblNumber || blToFill;
  }

  const renderContainerNumber = () => {
    return <FormItem {...formItemLayout} colon={false}
      label={containerLabel()} required={false}>
      {getFieldDecorator('containerNumber', {
        initialValue: getContainerInitialValue(),
        rules: [
          { required: true, message: 'Required' },
          { max: 25, message: 'Max length: 25' },
          { pattern: /^[^\s]+$/, message: 'No whitespace allowed' },
          { pattern: /^[a-zA-Z]{4}[0-9]{6,}$/, message: 'Wrong Container Number' }
        ],
      })(
        <Input
          onChange={e => validateContainerRegexAndSetField(e.target.value)}
          autoFocus
          disabled={isEdit(true)}
          placeholder="Container Number"
        />,
      )}
    </FormItem>;
  };

  const blLabel = () => {
    return <div className={classes.hintHeader}>
      BL Number
      {addType === 'BL' && <span className={classes.required}>*</span>}
    </div>;
  };

  const bookingLabel = () => {
    return <div className={classes.hintHeader}>
      Booking Number
      {addType === 'Booking' && <span className={classes.required}>*</span>}
    </div>;
  };

  function blNumberInitial(): string {
    let blNumber = editData?.blNumber || blToFill;
    if (editData?.shipmentType === SHIPMENT_TYPE.BL) blNumber = editData?.shipmentNumber;
    return blNumber;
  }

  const renderBLNumber = (required = true) => {
    return <FormItem {...formItemLayout} colon={false}
      label={blLabel()} required={false}>
      {getFieldDecorator('blNumber', {
        initialValue: blNumberInitial(),
        rules: [
          { required, message: 'Required' },
          { max: 25, message: 'Max length: 25' },
          { pattern: /^[^\s]+$/, message: 'No whitespace allowed' },
        ],
      })(
        <Input
          onChange={e => validateRegexAndSetField(e.target.value)}
          autoFocus
          disabled={isEdit(true) && required}
          placeholder="Bill of Lading Number"
        />,
      )}
    </FormItem>;
  };

  const renderHBLNumber = () => {
    return <FormItem {...formItemLayout} colon={false}
      label={getRequiredLabel('HBL Number')} required={false}>
      {getFieldDecorator('hblNumber', {
        initialValue: getHBLInitialValue(),
        rules: [
          { required: true, message: 'Required' },
          { max: 25, message: 'Max length: 25' },
          { pattern: /^[^\s]+$/, message: 'No whitespace allowed' }],
      })(
        <Input
          onChange={e => validateRegexAndSetField(e.target.value)}
          autoFocus
          disabled={isEdit(true)}
          placeholder="HBL Number"
        />
      )}
    </FormItem>;
  };

  function getBookingInitial(): string {
    let bookingNumber = editData?.bookingNumber || bookingToFill;
    if (editData?.trackingType === SHIPMENT_TYPE.BK) bookingNumber = editData?.shipmentNumber;
    return bookingNumber;
  }

  const renderBookingNumber = (required: boolean = true) => {
    return <FormItem
      {...formItemLayout}
      colon={false}
      label={bookingLabel()}
      required={false}>
      {getFieldDecorator('bookingNumber', {
        initialValue: getBookingInitial(),
        rules: [
          { required, message: 'Required' },
          { pattern: /^[^\s]+$/, message: 'No whitespace allowed' },
        ],
      })(
        <Input
          autoFocus={addType === 'Booking'}
          disabled={isEdit(true) && addType === 'Booking'}
          placeholder="Booking Number"
        />,
      )}
    </FormItem>;
  };

  const addCustomer = (visibleKey, label) => {
    if (!state[visibleKey]) return null;
    return <AddCustomer
      isVisible={state[visibleKey]}
      sendWeeklyReport={sendWeeklyReport}
      entityName={label}
      refresh={() => { }}
      onClose={() => setState({ [visibleKey]: false })}
    />;
  };

  const renderNumber = () => {
    switch (addType) {
      case 'Booking': return renderBookingNumber();
      case 'BL': return renderBLNumber();
      case 'HBL': return renderHBLNumber();
      default: return renderContainerNumber();
    }
  };

  const renderShipmentNumber = () => {
    return <Col span={12}>
      {renderNumber()}
    </Col>;
  };

  const getShippingLineLabel = (required: boolean = true) => {
    return <div
      className={classes.hintHeader}>
      Shipping Line
      {required && (<span className={classes.required}>
        *
      </span>)}
    </div>;
  };

  const getRequiredLabel = (text, required: boolean = true) => {
    return <div
      className={classes.hintHeader}>
      {text}
      {required && (<span className={classes.required}>
        *
      </span>)}
    </div>;
  };

  const renderShippingLine = (required: boolean = true) => {
    let shippingLines = getShippingLineDimensions;
    if (addType === 'Booking') {
      shippingLines = shippingLines.filter(shippingLine => (
        shippingLine.isBookingSupported
      ));
    }
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={getShippingLineLabel(required)}
        required={false}
      >
        {getFieldDecorator('shippingLine', {
          rules: [{ required, message: 'Required' }],
        })(<Select
          onSelect={(value)=> {
            if (!shippingLines || !shippingLines.length) return;
            const selectedLine = shippingLines.find((itm) => itm.id === value);
            if (selectedLine) {
              isManulShippingSelected.current = !selectedLine.isTrackingEnabled;
            }
          }}
          allowClear
          showSearch
          placeholder="Select Shipping Line"
          disabled={isEdit(true)}
          dropdownMatchSelectWidth={false}
          optionLabelProp={'data-value'}
          filterOption={(inputValue, option) => {
            if (!inputValue) return true;
            const optionval = option.props['data-value'] ?
              option.props['data-value'].trim().toLowerCase() : '';
            return optionval.includes(inputValue.trim().toLowerCase());
          }}>
          {generateOptionsFromList(shippingLines)}
        </Select>,
        )}
      </FormItem>
      {carrierAdvisories?.map(item => item.carrierId).indexOf(shippingLines?.find(item => (item.id === getFieldValue('shippingLine')))?.dbId) !== -1 ? <span className={classes.slDownText}>
        We are facing some issues in tracking containers on this shipping line, expect some delays in the updates.
      </span> : null}
    </Col>;
  };

  const renderCarrier = (required: boolean = true) => {
    const carriers = globalCarriers.filter((item) => item.type === 'HBL_VENDOR');
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={getRequiredLabel('Vendor', required)}
        required={false}>
        {getFieldDecorator('hblVendor', {
          rules: [{ required, message: 'Required' }],
          ...(linkedHblVendor && {initialValue: linkedHblVendor.id})
        })(<Select
          allowClear
          showSearch
          placeholder="Select Vendor"
          disabled={isEdit(true) || linkedHblVendor}
          dropdownMatchSelectWidth={false}
          optionLabelProp={'data-value'}
          filterOption={(inputValue, option) => {
            if (!inputValue) return true;
            const optionval = option.props['data-value'] ?
              option.props['data-value'].trim().toLowerCase() : '';
            return optionval.includes(inputValue.trim().toLowerCase());
          }}>
          {generateOptionsFromList(carriers)}
        </Select>,
        )}
      </FormItem>
    </Col>;
  };

  const renderNumberAndShippingLine = () => {
    return <Row gutter={24}>
      {renderShipmentNumber()}
      {addType !== SHIPMENT_TYPE.HBL ? renderShippingLine() : renderCarrier()}
    </Row>;
  };

  const renderField = () => {
    if (addType === 'BL') return renderBookingNumber(false);
    if (editData && addType === 'Booking') return renderBLNumber(false);
    return null;
  };

  const renderBookingOrBL = () => {
    const renderFieldHtml = renderField();
    return <Row gutter={24}>
      {renderFieldHtml && (<Col span={12}>
        {renderField()}
      </Col>)}
    </Row>;
  };

  function handleAutoFillProduct(e) {
    if (e.target.checked) {
      setProduct();
    }
  }

  const tooltipText = `Products mapped to the customer or supplier in
  the masters will be autofilled on enabling this option`;

  const renderProductCheckbox = () => {
    const { autoFillProduct } = editData || {};
    return <FormItem
      colon={false}
      style={{
        marginBottom: -16,
        marginLeft: -5,
      }}
    // {...formItemLayout}
    >
      {form.getFieldDecorator('autoFillProduct', {
        initialValue: isValidBoolean(autoFillProduct) ? autoFillProduct : false,
        valuePropName: 'checked',
      })(<Checkbox
        onChange={handleAutoFillProduct}
      >
        Auto-fill products for the customer/supplier <Tooltip title={tooltipText}>
          <Icon
            style={{ marginLeft: 10 }}
            theme="filled"
            type="info-circle"
          />
        </Tooltip>
      </Checkbox>)}
    </FormItem>;
  };

  async function searchProducts(searchQuery: string) {
    const response = await searchProduct({ searchQuery, status: 'ACTIVE' });
    setState({
      productList: (response?.data || []).map(item => ({
        key: item.id,
        label: item.internalName,
      })),
    });
  }

  const renderProductLabel = () => {
    return <div
      className={classes.hintHeader}
      style={{ paddingTop: 8 }}
    >
      <div style={{ lineHeight: '14px' }}> Product Name</div>
      <div style={{ lineHeight: '14px' }}>(Internal)</div>
    </div>;
  };

  const renderProductDropdown = () => {
    return <Row gutter={24}
      style={{
        paddingBottom: '10px',
      }}>
      <Col span={12}>
        <FormItem
          {...formItemLayout}
          colon={false}
          style={{
            marginTop: -12,
          }}
          label={<div className={classes.hintHeader} />}
        >
          {form.getFieldDecorator('productDetailIds', {
            initialValue: editData?.productDetails?.map(item => ({
              key: item.id,
              label: item.internalName,
            })),
          })(<SearchTagsInput
            searchFunction={searchProducts}
            placeholder="Search Product"
            options={productList}
            mode="multiple"
          />)}
        </FormItem>
      </Col>
      <Col span={12}></Col>
    </Row>;
  };

  const renderProductFields = () => {
    return <React.Fragment>
      {renderProductDropdown()}
    </React.Fragment>;
  };

  const renderCheckBox = () => {
    return <Row gutter={24}
      style={{ paddingBottom: '10px' }}>
      <Col span={3}>
        {renderProductLabel()}
      </Col>
      <Col span={21}>
        {renderProductCheckbox()}
      </Col>
    </Row>;
  };

  const renderSelectImportAddressModal = (): React.ReactElement => {
    return (
      <SelectImportAddressModal
        isVisible={isSelectAddressModalVisible}
        handleClose={() => setState({ isSelectAddressModalVisible: false })}
        handleDone={(selectedImportAddress) => setState({ isSelectAddressModalVisible: false, selectedImportAddress })}
        selectedImportAddress={selectedImportAddress}
        addressList={addressList}
        fetchAddressList={fetchAddressList}
        isFetchingAddress={isFetchingAddress}
      />
    );
  };

  const renderSONumber = () => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>SO Number</div>}>
        {getFieldDecorator('soNumber', {
          initialValue: editData?.soNumber,
        })(<Input
          placeholder="SO Number"
          style={{ width: '100%' }}
        />)}
      </FormItem>
    </Col>;
  }

  const renderStuffingId = () => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>Stuffing Id</div>}>
        {getFieldDecorator('stuffingId', {
          initialValue: editData?.stuffingId,
        })(<Input
          placeholder="Stuffing Id"
          style={{ width: '100%' }}
        />)}
      </FormItem>
    </Col>;
  }

  const renderIncoterms = () => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>Incoterm</div>}>
        {getFieldDecorator('incoterm', {
          initialValue: editData?.incoterm || undefined,
        })(<SelectIncoterm
          placeholder="Incoterm"
          style={{ width: '100%' }}
          allowedIncoterm={shippingModeToValidIncotermMapping?.FCL}
        />)}
      </FormItem>
    </Col>;
  }

  const renderCompany = () => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>Company</div>}>
        {getFieldDecorator('company', {
          initialValue: editData?.company,
        })(<Input
          placeholder="Company"
          style={{ width: '100%' }}
        />)}
      </FormItem>
    </Col>;
  }

  const renderBusiness = () => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>Business Location</div>}>
        {getFieldDecorator('businessLocation', {
          initialValue: editData?.businessLocation,
        })(<Input
          placeholder="Business Location"
          style={{ width: '100%' }}
        />)}
      </FormItem>
    </Col>;
  }

  const renderChannel = () => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>Channel</div>}>
        {getFieldDecorator('channel', {
          initialValue: editData?.channel,
        })(<Input
          placeholder="Channel"
          style={{ width: '100%' }}
        />)}
      </FormItem>
    </Col>;
  }


  const renderRow = (firstCol: ReactElement, secondCol?: ReactElement, addBottomPadding?: boolean) => {
    return <Row gutter={24} className={addBottomPadding ? classes.rowStyles: undefined}>
      {firstCol}
      {secondCol}
    </Row>;
  }

  const renderFields = (fields: ReactElement[]) => {
    if (!fields?.length) {
      return;
    }

    const grid: ReactElement[] = [];
    for (let idx = 0; idx < fields.length; idx += 2) {
      const isLastRow = idx + 2 >= fields.length;
      const row: ReactElement = renderRow(fields[idx], fields[idx+1], isLastRow);
      grid.push(row);
    }

    return grid;
  }
  let [apiTimeout, setApiTimeout] = React.useState<NodeJS.Timeout | null>(null);
  const [shipmentOwnerList, setShipmentOwnerList] :any = React.useState([]);
  const [shipmentOwnerSelected, setShipmentOwnerSelected] = React.useState();

  const handleShipmentOwnerSearch = (value: string) => {
    if (apiTimeout) {
      clearTimeout(apiTimeout);
      setApiTimeout(null);
    }
    setState({ searching: true });
    setApiTimeout(setTimeout(async () => {
      const response = await fetchAllUsersOfCurrentOrg();
      setState({ searching: false });
      if (response.isSuccess) {
        const shipmentOwners =  response.data?.filter((user)=> user.name && user.status === 'ACTIVE') || [];
        setShipmentOwnerList(
          shipmentOwners
        );
      }
    }, 300));
  };

  const renderShipmentOwnerSearch = () => {
    return <Col span={12}>
      <FormItem
        {...formItemLayout}
        colon={false}
        label={<div className={classes.hintHeader}>Shipment Owner</div>}>
        {getFieldDecorator('shipmentOwner', {
            initialValue: editData?.shipmentOwner ?? undefined,
        })(<Select
          allowClear
          showSearch
          value={shipmentOwnerSelected}
          onChange={(filterVals, options) => {
            setShipmentOwnerSelected(filterVals);
          }}
          placeholder="Select Owner"
          onSearch={handleShipmentOwnerSearch}
          onFocus={() => handleShipmentOwnerSearch('')}
          notFoundContent={searching ? renderLoading(searching): 'Not Found'}
          style={{ width: '100%', marginBottom: '5px' }}>
          {
            (shipmentOwnerList?.map(item =>
              <Select.Option key={item.name}>
                <Tooltip placement="right" title={item.name}>{item.name}</Tooltip>
              </Select.Option>) || [])
          }
        </Select>,
        )}
      </FormItem>
    </Col>
  };

  return (
    <>
  <Modal
    title={editData ? 'Edit Tracking' : 'Tracking'}
    visible={isVisible}
    width={900}
    okText={editData ? 'Update' : 'Create'}
    onCancel={() => onClose({})}
    destroyOnClose
    onOk={() => onModalOk()}
    style={{ minWidth: MIN_WIDTH }}
    footer={null}
    zIndex={1000}
    confirmLoading={isSaving}
  >
    <Form layout="inline"
      className={classes.form}>
      {renderRadioGroup()}
      {renderNumberAndShippingLine()}
      {renderBookingOrBL()}
      {renderAddMovementTypeAndCode()}
      {renderSupplierFields()}
      {renderShipmentOwnerAndPurchaseOrder()}
      {renderAccessTypeAndVendor()}
      {renderCheckBox()}
      {renderProductFields()}
      {
        renderFields(addType === TrackingTypeLabel.CONTAINER ? [
          renderSONumber(), renderStuffingId(),
          renderIncoterms(), renderCompany(),
          renderBusiness(), renderChannel()
        ] : [renderIncoterms()])
      }
      {renderManualTrackingForm()}
      {renderAdditionalInfo()}
      {renderDemurrageDetails()}
      {renderDocumentDetails()}
      {renderButton()}
    </Form>
    {addCustomer('isAddCustomerModal', getDisplayLabelForUser)}
    {addCustomer('isAddSupplierModal', 'Supplier')}
    {isSelectAddressModalVisible && renderSelectImportAddressModal()}
  </Modal>
      {isErrorModalVisible && (
        <TrackingDuplicateConfirmationModal
          failureArray={failureArray || []}
          isVisible={isErrorModalVisible}
          onModalClose={handleErrorModalClose}
        />
      )}
    </>
  );
};

const mapStateToProps = ({ masterData, staticData, shipmentTrackingReducer }, ownProps) => {
  return {
    getShippingLineDimensions: masterData.globalShippingLines,
    globalCarriers: masterData.globalCarriers,
    linkedHblVendor: masterData?.linkedHblVendor,
    blRegexshippingLineMap: masterData.containerTracking.blRegexshippingLineMap,
    containerRegexshippingLineMap: masterData.containerTracking.containerRegexshippingLineMap,
    containerSize: staticData.containerSize,
    containerTypesKeyVal: staticData.containerTypesKeyVal,
    userData: masterData.userData,
    showContainerTriangulation: masterData.modules.show_container_triangulation,
    visibleAccessTypes: masterData?.visibleAccessTypes?.CONTAINER_TRACKING ?? [],
    carrierAdvisories: shipmentTrackingReducer.carrierAdvisories,
    sendWeeklyReport: masterData.sendWeeklyEtaReport,
    allowedDocumentTypes: masterData?.execution?.allowedDocumentTypes,
    shippingModeToValidIncotermMapping: masterData?.execution?.shippingModeToValidIncotermMapping,
    organisationId: masterData.userData?.organisation_id
  };
};

const StyledQuickAdd = injectSheet(QuickAddContainerTrackingStyles)(QuickAddContainerTracking);

const connector = connect(mapStateToProps);

type ReduxProps = ConnectedProps<typeof connector>;

export default withRouter(connector(Form.create()(StyledQuickAdd)));
